export const LOAN_PALIERS_MIN = 2;
export const LOAN_PALIERS_MAX = 10;

export const LOAN_DIFFERE_NONE = '_';

export const LOAN_PALIERS_CONTROL = 'paliers';
export const LOAN_PALIERS_ENABLED_CONTROL = 'paliersEnabled';

export const LOAN_MODE_CONTROL = 'mode';
export const LOAN_DIFFERE_CONTROL = 'differe';
export const LOAN_DURATION_DIFFERE_CONTROL = 'durationDiffereInMonth';

export const LOAN_PALIER_DURATION_CONTROL = 'durationInMonth';
export const LOAN_PALIER_MONTHLY_PAYMENT_CONTROL = 'monthlyPayment';
export const LOAN_PALIER_DIFFERE_CONTROL = 'differe';

export type LoanDiffere = 'PARTIEL' | 'TOTAL';

export type LoanType = 'FIX' | 'IN_FINE';

export type LoanInsuranceType = 'AMOUNT_BORROWED' | 'LOAN_LEFT';

export type LoanStepPeriod = 'BEFORE' | 'DIFFERE' | 'LOAN' | 'AFTER';

export interface LoanPalier {
  durationInMonth?: number;
  monthlyPayment?: number;
  differe?: LoanDiffere;
}

export interface LoanPalierFormValue {
  durationInMonth?: string | number | null;
  monthlyPayment?: string | number | null;
  differe?: string | null;
}

export interface LoanInsuranceQuotite {
  ownerId?: number;
  quotite: number;
}

export interface LoanStep {
  period?: LoanStepPeriod;
  monthNumber?: number;
  date?: string;
  month?: number;
  year?: number;
  loanMonth?: number;
  interestMonth?: number;
  insuranceMonth?: number;
  totalMonth?: number;
  loanLeft?: number;
  interestLeft?: number;
  insuranceLeft?: number;
  totalLeft?: number;
  loanPaid?: number;
  interestPaid?: number;
  insurancePaid?: number;
  totalPaid?: number;
  interestRate?: number;
}

export interface LoanComputationModel {
  type: LoanType;
  amountBorrowed?: number;
  amountFee?: number;
  interestRate?: number;
  insuranceRate?: number;
  insuranceType?: LoanInsuranceType;
  insuranceQuotite?: LoanInsuranceQuotite[];
  durationTotalInMonth?: number;
  startDate?: string;
  paliers?: LoanPalier[];
}

export interface LoanComputationResult extends LoanComputationModel {
  steps?: LoanStep[];
  amountMonthly?: number;
  amountTotal?: number;
  loanTotalCost?: number;
  taeg?: number;
}

export interface LoanPalierIssue {
  message: string;
  palierIndex?: number;
  field?:
    | typeof LOAN_PALIER_DURATION_CONTROL
    | typeof LOAN_PALIER_MONTHLY_PAYMENT_CONTROL
    | typeof LOAN_PALIER_DIFFERE_CONTROL;
}

export interface LoanPalierRange {
  index: number;
  startMonth: number;
  endMonth: number;
  differe?: LoanDiffere;
}
